import { Link } from "react-router-dom";
import { SERVICES } from "../../data/services";

// SOFTCAT 디자인 시스템 푸터 — 거대 워드마크 + 링크 열.
//
// 링크는 <Link>(= <a href>) 로 둔다. 예전엔 <button onClick> 이라 검색엔진이
// 따라가지 못했다. 서비스 페이지는 모든 화면 아래에서 링크가 걸리도록 여기 둔다.
export default function Footer() {
    const top = () => window.scrollTo(0, 0);

    return (
        <footer style={{ borderTop: "1px solid var(--ink)" }}>
            <div className="sch-wrap sch-foot">
                <div className="sch-foot__grid">
                    <div>
                        <img
                            src="/images/softcat_new_logo2.png"
                            alt="SOFTCAT"
                            style={{ height: "24px", marginBottom: "16px" }}
                        />
                        <ul>
                            <li>오전 09시 ~ 오후 18시 (주말, 공휴일 제외)</li>
                            <li>oracle7579@gmail.com · 010-4414-7579</li>
                        </ul>
                    </div>

                    <div>
                        <h4>MENU</h4>
                        <ul>
                            <li><Link className="sch-footlink" to="/about" onClick={top}>회사 소개</Link></li>
                            <li><Link className="sch-footlink" to="/portfolio" onClick={top}>포트폴리오</Link></li>
                            <li><Link className="sch-footlink" to="/blog" onClick={top}>블로그</Link></li>
                            <li><Link className="sch-footlink" to="/custom-product-first" onClick={top}>맞춤 개발 문의</Link></li>
                            <li><Link className="sch-footlink" to="/service" onClick={top}>고객지원</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4>SERVICE</h4>
                        <ul>
                            {SERVICES.map((sv) => (
                                <li key={sv.slug}>
                                    <Link className="sch-footlink" to={`/service/${sv.slug}`} onClick={top}>{sv.nav}</Link>
                                </li>
                            ))}
                            <li><Link className="sch-footlink" to="/pricing" onClick={top}>개발 비용</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4>POLICY</h4>
                        <ul>
                            <li><Link className="sch-footlink" to="/privacy-policy" onClick={top}>개인정보 처리방침</Link></li>
                            <li><Link className="sch-footlink" to="/cookie-policy" onClick={top}>쿠키 정책</Link></li>
                            <li><Link className="sch-footlink" to="/term-of-use" onClick={top}>서비스 이용 약관</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="sch-foot__big">SOFTCAT</div>

                <div className="sch-foot__biz">
                    소프트캣 · 대표 : 박찬엽 · 주소 : 경기도 고양시 덕양구 원흥3로 16 904호 ·
                    사업자 등록번호 : 292-56-00756 · 통신판매업 신고번호 : 2025-고양덕양구-0992호
                </div>
            </div>
        </footer>
    );
}
